import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import TeleConsultation from './pages/TeleConsultation';
import VisionTest from './pages/VisionTest';
import FollowUp from './pages/FollowUp';
import FindHelp from './pages/FindHelp';
import Layout from './components/Layout';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import EyeEducation from './pages/EyeEducation';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tele-consultation" element={<TeleConsultation />} />
          <Route path="/vision-test" element={<VisionTest />} />
          <Route path="/follow-up" element={<FollowUp />} />
          <Route path="/find-help" element={<FindHelp />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/eye-education" element={<EyeEducation />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;

